<template>
  <BaseModal
    :dialog.sync="dialog"
    @close="handleClose"
    :title="modalTitle"
    :key="ticketData.idproduto_variacao"
  >
    <v-row>
      <v-col cols="12" md="6">
        <TopicTitle
          :icon="'mdi-text'"
          :title="$t('new-event.ticket-management.recharges.modal.desc')"
          :subtitle="
            $t('new-event.ticket-management.recharges.modal.desc-description')
          "
        />
        <BaseTextarea
          persistent-placeholder
          :label="`${$t(
            'new-event.ticket-management.recharges.modal.inputs.description'
          )} ${selectedLocales.length > 0 ? `(${getTextLocale(locale)})` : ''}`"
          v-model="descriptionDefault"
          :key="ticketData.idproduto_variacao + '-description-default-locale-2'"
          counter="500"
          maxlength="500"
        />
        <v-col
          v-for="(locale, index) in selectedLocales"
          :key="index"
          class="pa-0 ma-0 mt-4"
        >
          <BaseTextarea
            persistent-placeholder
            :label="`${$t(
              'new-event.ticket-management.recharges.modal.inputs.description'
            )} (${getTextLocale(locale)})`"
            v-model="descriptionLocales[locale]"
            :id="`description-${index}`"
            :key="ticketData.idproduto_variacao + '-description-' + locale"
            counter="500"
            maxlength="500"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="6">
        <TopicTitle
          :icon="'mdi-store-outline'"
          :title="
            $t('new-event.ticket-management.recharges.modal.sales-channel')
          "
          :subtitle="
            $t(
              'new-event.ticket-management.recharges.modal.sales-channel-description'
            )
          "
        />
        <BaseSelect
          :items="filtredSalesChannel()"
          :label="
            $t(
              'new-event.ticket-management.recharges.modal.inputs.sales-channel'
            )
          "
          class="self-end"
          v-model="ticketData.salesChannel"
          item-text="value"
          item-value="key"
          :key="ticketData.idproduto_variacao + '-sales-channel-2'"
          disabled
        />
      </v-col>
    </v-row>
    <v-row v-if="isAdmin">
      <v-col md="6" cols="12" class="pb-0">
        <TopicTitle
          class="mb-4"
          :title="$t('new-event.ticket-management.recharges.modal.comission')"
          :subtitle="
            $t(
              'new-event.ticket-management.recharges.modal.comission-description'
            )
          "
          icon="mdi-cash-refund"
        />

        <BaseSelect
          class="mb-4"
          :items="commissionType"
          item-text="item"
          item-value="value"
          :label="`${$t(
            'new-event.ticket-management.recharges.modal.inputs.comission'
          )} Web`"
          persistent-placeholder
          v-model="ticketData.commissionWeb"
          :key="ticketData.idproduto_variacao + '-comission-web-2'"
        ></BaseSelect>
        <v-row class="mt-1">
          <v-col cols="12" md="6">
            <BaseSelect
              item-value="value"
              item-text="item"
              :items="typeTax"
              :label="`${$t(
                'new-event.ticket-management.recharges.modal.inputs.type-tax'
              )} WEB`"
              persistent-placeholder
              v-model="ticketData.typeTaxWeb"
              :key="ticketData.idproduto_variacao + '-type-tax-web-2'"
            />
          </v-col>
          <v-col cols="12" md="6">
            <BaseMoneyField
              v-if="ticketData.typeTaxWeb === 'percent'"
              class="mb-4"
              v-model="ticketData.taxWeb"
              :label="`${$t(
                'new-event.ticket-management.recharges.modal.inputs.tax'
              )} (%)`"
              persistent-placeholder
              :options="optionsPercent"
              :key="ticketData.idproduto_variacao + '-tax-web-1'"
              :rules="[rules.maxLimit]"
              selectContent
            />
            <BaseMoneyField
              v-else
              class="mb-4"
              v-model="ticketData.taxWeb"
              :label="`${$t(
                'new-event.ticket-management.recharges.modal.inputs.tax'
              )} (R$)`"
              persistent-placeholder
              :options="optionsCurrency"
              :key="ticketData.idproduto_variacao + '-tax-web-2'"
              selectContent
            />
          </v-col>
        </v-row>
        <BaseMoneyField
          v-model="ticketData.minimumTax"
          :label="`${$t(
            'new-event.ticket-management.recharges.modal.inputs.min-tax'
          )} (R$)`"
          persistent-placeholder
          :options="optionsCurrency"
          :key="ticketData.idproduto_variacao + '-min-tax-2'"
          selectContent
          hide-details="auto"
        />
        <v-checkbox
          hide-details
          :label="
            $t(
              'new-event.ticket-management.recharges.modal.inputs.has-process-tax'
            )
          "
          v-model="ticketData.hasProcessingTax"
          :key="ticketData.idproduto_variacao + 'has-process-tax-2'"
          dense
        />
        <v-col v-if="ticketData.hasProcessingTax" cols="12" class="pl-0">
          <BaseMoneyField
            :options="optionsCurrency"
            v-model="ticketData.processingTax"
            :label="`${$t(
              'new-event.ticket-management.recharges.modal.inputs.process-tax'
            )} (R$)`"
            persistent-placeholder
            :key="ticketData.idproduto_variacao + 'processing-tax-2'"
            selectContent
          />
        </v-col>
      </v-col>

      <v-col md="6" cols="12" class="pb-0">
        <TopicTitle
          class="mb-4"
          :title="$t('new-event.ticket-management.recharges.modal.eleven-cash')"
          :subtitle="elevenCashHint"
          icon="mdi-credit-card-wireless-outline"
        />
        <BaseTextField
          :label="
            $t('new-event.ticket-management.recharges.modal.inputs.eleven-cash')
          "
          v-model="ticketData.elevenCash"
          :key="ticketData.idproduto_variacao + '-eleven-cash'"
          :disabled="!hasToken"
          persistent-hint
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-end mt-2 flex-wrap">
        <v-btn
          class="rounded-pill primary--text mr-2 mb-2"
          outlined
          @click="handleClose"
          >{{ $t("new-event.buttons.cancel") }}</v-btn
        >
        <v-btn
          class="rounded-pill primary"
          variant="flat"
          @click="handleSave"
          :loading="getModalLoadingEvent"
          >{{ $t("new-event.buttons.confirm-adjusts") }}</v-btn
        >
      </v-col>
    </v-row>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/events/EventSettingsModal/BaseModal.vue";
import TopicTitle from "../../TopicTitle.vue";
import BaseSelect from "../../forms/BaseSelect.vue";
import BaseTextarea from "../../forms/BaseTextarea.vue";
import BaseMoneyField from "../../forms/BaseMoneyField.vue";
import BaseTextField from "../../forms/BaseTextField.vue";
import { mapActions, mapGetters } from "vuex";
import {
  getTextLocale,
  processEventName,
  optionsCurrency,
  optionsPercent,
  filtredSalesChannel,
} from "@/utils";
import mixins from "@/mixins";
const { formRules } = mixins;

export default {
  components: {
    BaseModal,
    TopicTitle,
    BaseSelect,
    BaseTextarea,
    BaseMoneyField,
    BaseTextField,
  },
  mixins: [formRules],
  data() {
    return {
      getTextLocale,
      filtredSalesChannel,
      ticketData: {},
      descriptionDefault: "",
      descriptionLocales: {},
      optionsCurrency,
      optionsPercent,
      blockQuantityCantBeMoreThanQuantity: value => {
        const isValidNumber =
          value !== undefined && value !== null && +value >= 0;
        if (isValidNumber && +value <= this.ticketData.quantity) {
          return true;
        }
        return this.$t("common.block-quantity-bigger-than-stock");
      },
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    eventData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters([
      "getSelectedLocales",
      "isAdmin",
      "storeInfo",
      "getModalLoadingEvent",
    ]),
    elevenCashHint() {
      const link = `/produtores/editar/${this.storeInfo.idloja}`;
      return `${this.$t(
        "new-event.ticket-management.recharges.modal.inputs.eleven-cash-hint"
      )} <a href="${link}" target="_blank" style="color: #1976d2; text-decoration: underline;">
    ${this.$t(
      "new-event.ticket-management.recharges.modal.inputs.eleven-click-here"
    )}
  </a>`;
    },

    hasToken() {
      return !!this.storeInfo.token_cashless;
    },
    modalTitle() {
      const title = this.ticketData.price || this.$t("common.no-price");
      return `
      ${this.$t("new-event.ticket-management.recharges.modal.title")}
      <span class='primary--text'>${title}</span>
    `;
    },
    commissionType() {
      return [
        {
          item: this.$t("new-event.settings.comission-type.comission"),
          value: "COMISSAO",
        },
        {
          item: this.$t("new-event.settings.comission-type.convenience"),
          value: "CONVENIENCIA",
        },
      ];
    },
    typeTax() {
      return [
        {
          item: this.$t("new-event.settings.type-tax.percent"),
          value: "percent",
        },
        {
          item: this.$t("new-event.settings.type-tax.value"),
          value: "value",
        },
      ];
    },
    selectedLocales() {
      return this.getSelectedLocales;
    },
    locale() {
      return this.$i18n.locale;
    },
    formattedEventDescriptions() {
      const defaultDescription = `<${this.locale}>${
        this.descriptionDefault || ""
      }</${this.locale}>`;

      if (this.selectedLocales.length === 0) {
        return defaultDescription;
      }
      const allLocales = this.selectedLocales
        .map(selectedLocale => {
          const description =
            this.descriptionLocales[selectedLocale]?.trim() || "";
          return `<${selectedLocale}>${description}</${selectedLocale}>`;
        })
        .join("");

      return defaultDescription + allLocales;
    },
    hintBlockTickets() {
      const remainingTickets =
        (this.ticketData.quantity || 0) - (this.ticketData.blockQuantity || 0);

      return (
        this.$t(
          "new-event.ticket-management.tickets.modal.hint-block-tickets"
        ) +
        " " +
        remainingTickets
      );
    },
  },
  methods: {
    ...mapActions(["updateEvent"]),
    handleClose() {
      this.ticketData = {};
      this.descriptionDefault = "";
      this.descriptionLocales = {};
      this.$emit("close");
    },
    async handleSave() {
      this.ticketData.description = this.formattedEventDescriptions;
      await this.$emit("update:eventData", this.ticketData);
      await this.updateEvent();
      this.descriptionLocales = {};
      this.descriptionDefault = "";
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.ticketData = { ...this.eventData };
        if (this.ticketData?.description) {
          const descriptions = processEventName(this.ticketData.description);
          this.descriptionDefault = descriptions[this.locale] || "";
          this.descriptionLocales = descriptions;
        }
      } else {
        this.ticketData = {};
      }
    },
  },
};
</script>

<style scoped></style>
